declare const __APP_VERSION__: string;

export function VersionBadge() {
  const handleClick = () => {
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(__APP_VERSION__).catch(() => {});
    }
  };

  return (
    <footer
      data-testid="version-badge"
      onClick={handleClick}
      title="Click to copy version"
      style={{
        padding: "12px",
        fontSize: 11,
        color: "rgb(180, 180, 180)",
        fontFamily: "monospace",
        cursor: "pointer",
        userSelect: "none",
        letterSpacing: "0.04em",
      }}
    >
      v{__APP_VERSION__}
    </footer>
  );
}
